export const ROLES = [
  {
    name: 'Administrador',
    value: 1,
  },
  {
    name: 'Cliente',
    value: 2,
  },
  {
    name: 'Administrador OPL',
    value: 3,
  },
  {
    name: 'Operador OPL',
    value: 4,
  },
  {
    name: 'Administrador PaQuery Point',
    value: 7,
  },
  {
    name: 'Operador PaQuery Point',
    value: 8,
  },
  {
    name: 'Administrador MP',
    value: 5,
  },
  {
    name: 'Operador MP',
    value: 6,
  },
  {
    name: 'Operador Tienda',
    value: 12,
  },
  {
    name: 'Administrador Tienda',
    value: 11,
  },
];

export const ROLE = {
  OPL_ADMIN: 3,
  OPL_OPERATOR: 4,
  PP_ADMIN: 7,
  PP_OPERATOR: 8,
};

export const LogisticOperatorRoles = [ROLE.OPL_ADMIN, ROLE.OPL_OPERATOR];
export const PaqueryPointRoles = [ROLE.PP_ADMIN, ROLE.PP_OPERATOR];
export const MarketplaceRoles = [5, 6];
export const StoreRoles = [11, 12];

/** Roles que pueden entrar a la webapp unificada. */
export const APP_ROLES = [...LogisticOperatorRoles, ...PaqueryPointRoles];

export const ADMIN_ROLES = [ROLE.OPL_ADMIN, ROLE.PP_ADMIN];

export const isOplRole = (roleId) => LogisticOperatorRoles.includes(roleId);
export const isPaqueryPointRole = (roleId) =>
  PaqueryPointRoles.includes(roleId);

/**
 * Administrador de su propio ámbito: rol 3 para OPL, rol 7 para PaQuery Point.
 * Reemplaza a los dos `isProfileAdministrator` que existían por separado en
 * webapp-opl y webapp-paquery-point.
 */
export const isProfileAdministrator = (profile) =>
  ADMIN_ROLES.includes(profile?.userRoleID);

/**
 * Permisos granulares que el backend devuelve en `profile.userRoleActions`.
 * ponytail: sólo estos dos están confirmados; falta el catálogo completo del backend.
 */
export const PERMISSIONS = {
  AddEditPaquer: 'Paquers-edit',
  AlterMarketplace: 'Marketplace',
};

export const hasPermission = (profile, permission) =>
  Array.isArray(profile?.userRoleActions) &&
  profile.userRoleActions.includes(permission);
